module.exports = __webpack_public_path__ + "static/media/signage-indoor-img74.c305bf51.jpg";